// extracted by mini-css-extract-plugin
export default {"services":"ourServices_services__X7+tq","servicesCat":"ourServices_servicesCat__JzeO3"};